import GenericIdValueList from "./GenericIdValueList";
import {keys} from "../config/nameSpacesKeys";
import {assetKeys} from "../config/constants";

export default class Modality {
  constructor(name, initialValue, namespace) {
    this.namespace = namespace;
    this.name = name;
    // this.mediaTypeNameSpace = mediaTypeNameSpace;
    this.mediaType = new GenericIdValueList("mediaType", null, keys.msmediaType);

    if (initialValue) {
      this.parseInputJSON(initialValue);
    }
  }

  getNameSpace() {
    return this.namespace;
  }

  getExpandedFormatValue() {
    const obj = {};
    obj[this.mediaType.getNameSpace()] = this.mediaType.getExpandedFormatValue();
    obj[assetKeys.type] = [`${keys.modalityType}`];
    return obj;
  }

  parseInputJSON(inputJSON) {
    if (!inputJSON) {
      return;
    }
    const obj = inputJSON; // [this.namespace];
    if (Array.isArray(obj)) {
      for (const entry of Object.entries(obj)) {
        const value = entry[1];
        this.setValueObj(value);
      }
    } else {
      this.setValueObj(obj);
    }
  }

  setValueObj(obj) {
    this.mediaType.parseInputJSON(obj);
  }

  isEmpty() {
    return this.mediaType.isEmpty();
  }
}
